import { useEffect } from 'react';
import MainLayout from '../layouts/MainLayout';
import { Link, useLocation } from 'react-router-dom';
import economyimg from '../assets/img/economy.png';
import originimg from '../assets/img/omkar-das/omkar-das.png';
import womanImg from '../assets/img/woman.jpg';
import ganeshImg from '../assets/img/ganesha.jpg';
import mahawarImg from '../assets/img/building/building-image.jpeg';
import rajeevImg from '../assets/img/testimonials/rajeev-gupta.png';
import nareshImg from '../assets/img/testimonials/Naresh-Gupta.jpeg';
import subodhImg from '../assets/img/testimonials/Subodh-Gupta.jpeg';
import kapilImg from '../assets/img/testimonials/Kapil-Gupta.jpeg';
import amitImg from '../assets/img/testimonials/Amit-Gupta.jpeg';
import niranjanImg from '../assets/img/testimonials/Niranjan-Lal-Gupta.jpeg';
import anilImg from '../assets/img/testimonials/Anil-Kumar-Gupta.jpeg';
import tejparkashImg from '../assets/img/testimonials/Tejparkash.jpeg';
import HemantguptaImg from '../assets/img/testimonials/Hemant-Gupta.jpeg';
import holi2Img from '../assets/img/holi/holi-1.png';
import holi1Img from '../assets/img/holi/holi-2.png';
import blooddonation from '../assets/img/blood-donation/blood-donation-7.png';
import anualday from '../assets/img/anual-day/anual-day-2.png';
import planting from '../assets/img/planting/planting-2.png';

// Dynamically import all PNG images from the 1940-Mahasabha folder
const mahasabhaContext = require.context('../assets/img/1940-Mahasabha', false, /\.png$/i);
const mahasabhaImages = mahasabhaContext.keys().map((key) => mahasabhaContext(key).default || mahasabhaContext(key));
const mediaContext = require.context('../assets/img/media2', false, /\.png$/i);
const mediaImages = mediaContext.keys().map((key) => mediaContext(key).default || mediaContext(key));

function Home() {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.substring(1));
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100); // Small timeout to ensure DOM is fully rendered before scrolling
            }
        } else {
            window.scrollTo(0, 0); // Scroll to top if no hash is present
        }
    }, [hash]);

    return (
        <MainLayout>
            <section id="heroCarousel" className="carousel slide carousel-fade hero-section position-relative vh-100" data-bs-ride="carousel" data-bs-interval="5000">
                {/* Dark Overlay */}
                <div className="hero-overlay position-absolute top-0 start-0 w-100 h-100 z-1"></div>

                <div className="carousel-inner h-100 z-2 position-relative">
                    {/* Slide 1: Welcome & Intro */}
                    <div className="carousel-item active h-100">
                        <div className="d-flex align-items-center justify-content-center text-center text-white h-100">
                            <div className="container position-relative px-3 px-md-5">
                                <div className="row justify-content-center">
                                    <div className="col-lg-10 col-xl-8">
                                        <h3 className="h3 fw-medium text-uppercase tracking-wide mb-3 text-light" style={{ fontSize: 'clamp(1.2rem, 4vw, 2rem)' }}>
                                            महावर वैश्य (बनिया) समुदाय
                                        </h3>
                                        <h2 className="display-1 fw-bolder mb-4 animated-gradient-text" style={{ fontSize: 'clamp(2.5rem, 8vw, 5rem)' }}>
                                            महावर सभा (रजि.),रेवाड़ी
                                        </h2>
                                        <p className="lead fw-medium text-light mx-auto" style={{ maxWidth: '750px' }}>
                                            एक मान्यता प्राप्त सांस्कृतिक और कल्याणकारी संस्था — जो परंपराओं को बनाए रखने, पारिवारिक एकता को बढ़ावा देने और समुदाय की भलाई में सहयोग करने के लिए प्रतिबद्ध है।
                                        </p>
                                        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                                            <a href="#about" className="btn btn-danger btn-lg rounded-pill px-5 py-3 hero-btn solid-btn shadow-lg">
                                                About Us
                                            </a>
                                            <a href="#contact" className="btn btn-outline-light btn-lg rounded-pill px-5 py-3 hero-btn outline-btn shadow-lg">
                                                Contact Us
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Slide 2: Infrastructure & Youth */}
                    <div className="carousel-item h-100 bg-dark position-relative overflow-hidden">
                        <div className="position-absolute top-0 start-0 w-100 h-100" style={{ backgroundImage: `url(${anualday})`, backgroundSize: 'cover', backgroundPosition: 'center', filter: 'blur(1px)', opacity: 0.6, transform: 'scale(1.1)', zIndex: 0 }}></div>
                        <img src={anualday} className="d-block w-100 h-100 img-responsive position-relative z-1" style={{ objectFit: 'contain' }} alt="Mahawar Sabha Building" />
                    </div>

                    {/* Slide 3: Image Slide */}
                    <div className="carousel-item h-100 bg-dark position-relative overflow-hidden">
                        <div className="position-absolute top-0 start-0 w-100 h-100" style={{ backgroundImage: `url(${holi2Img})`, backgroundSize: 'cover', backgroundPosition: 'center', filter: 'blur(1px)', opacity: 0.6, transform: 'scale(1.1)', zIndex: 0 }}></div>
                        <img src={holi2Img} className="d-block w-100 h-100 img-responsive position-relative z-1" style={{ objectFit: 'contain' }} alt="Mahawar Sabha Building" />
                    </div>

                    {/* Slide 4: Infrastructure & Youth */}
                    <div className="carousel-item h-100 bg-dark position-relative overflow-hidden">
                        <div className="position-absolute top-0 start-0 w-100 h-100" style={{ backgroundImage: `url(${holi1Img})`, backgroundSize: 'cover', backgroundPosition: 'center', filter: 'blur(1px)', opacity: 0.6, transform: 'scale(1.1)', zIndex: 0 }}></div>
                        <img src={holi1Img} className="d-block w-100 h-100 img-responsive position-relative z-1" style={{ objectFit: 'contain' }} alt="Mahawar Sabha Building" />
                    </div>
                    {/* Slide 5: Infrastructure & Youth */}
                    <div className="carousel-item h-100 bg-dark position-relative overflow-hidden">
                        <div className="position-absolute top-0 start-0 w-100 h-100" style={{ backgroundImage: `url(${blooddonation})`, backgroundSize: 'cover', backgroundPosition: 'center', filter: 'blur(1px)', opacity: 0.6, transform: 'scale(1.1)', zIndex: 0 }}></div>
                        <img src={blooddonation} className="d-block w-100 h-100 img-responsive position-relative z-1" style={{ objectFit: 'contain' }} alt="Mahawar Sabha Building" />
                    </div>
                </div>

                {/* Subtle Carousel Arrows */}
                <button className="carousel-control-prev border-0 bg-transparent position-absolute start-0 top-50 translate-middle-y px-1 px-md-4 text-white opacity-50 hover-opacity-100 transition-opacity z-3 " type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon hero-carousel-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next border-0 bg-transparent position-absolute end-0 top-50 translate-middle-y px-1 px-md-4 text-white opacity-50 hover-opacity-100 transition-opacity z-3" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon hero-carousel-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </section>


            {/* Features Section */}
            <section id="features" className="features-section py-5 bg-light">
                <div className="container py-4">
                    <div className="row g-4 text-center">


                        {/*  Side: Notification */}
                        <div className="col-lg-6">
                            <div className="row g-4">
                                <h4 className="fw-bold mb-3 feature-title fs-5">सभा के मुख्य उद्देश्य</h4>
                                {/* Feature 1 */}
                                <div className="col-md-6">
                                    <div className="feature-box  h-100">
                                        <div className="icon-box mx-auto mb-4 d-flex align-items-center justify-content-center">
                                            <i className="bi bi-people fs-2"></i>
                                        </div>
                                        <h4 className="fw-bold mb-3 feature-title fs-5">सामुदायिक एकता</h4>
                                        <p className=" mb-0 fs-6">महावर परिवारों के बीच सामाजिक संबंधों को मजबूत करना और सद्भाव को बढ़ावा देना।</p>
                                    </div>
                                </div>
                                {/* Feature 2 */}
                                <div className="col-md-6">
                                    <div className="feature-box  h-100">
                                        <div className="icon-box mx-auto mb-4 d-flex align-items-center justify-content-center">
                                            <i className="bi bi-book fs-2"></i>
                                        </div>
                                        <h4 className="fw-bold mb-3 feature-title fs-5">शैक्षिक सहायता</h4>
                                        <p className=" mb-0 fs-6">हमारे युवाओं के लिए छात्रवृत्ति, मार्गदर्शन और करियर के अवसर प्रदान करना।</p>
                                    </div>
                                </div>
                                {/* Feature 3 */}
                                <div className="col-md-6">
                                    <div className="feature-box h-100">
                                        <div className="icon-box mx-auto mb-4 d-flex align-items-center justify-content-center">
                                            <i className="bi bi-heart-pulse fs-2"></i>
                                        </div>
                                        <h4 className="fw-bold mb-3 feature-title fs-5">समाज कल्याण</h4>
                                        <p className=" mb-0 fs-6">चिकित्सा शिविरों, अन्न दान और जरूरतमंद परिवारों के लिए सहायता का आयोजन करना।</p>
                                    </div>
                                </div>
                                {/* Feature 4 */}
                                <div className="col-md-6">
                                    <div className="feature-box  h-100">
                                        <div className="icon-box mx-auto mb-4 d-flex align-items-center justify-content-center">
                                            <i className="bi bi-bank fs-2"></i>
                                        </div>
                                        <h4 className="fw-bold mb-3 feature-title fs-5">सांस्कृतिक संरक्षण</h4>
                                        <p className=" mb-0 fs-6">त्योहारों को मनाना और आने वाली पीढ़ियों के लिए हमारी समृद्ध परंपराओं को जीवित रखना।</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">

                            <h4 className="fw-bold mb-5 feature-title fs-5 "> <i className="bi bi-bell fs-5"></i> Notification</h4>
                            <div className="card p-4 shadow-sm rounded-4 border-0 hover-lift">
                                <div className="mb-0 fs-6">
                                    <h6>✨ पावन आमंत्रण ✨</h6>
                                    <p style={{ fontSize: '20px', fontWeight: 'bold', color: '#b38600', marginTop: '5px' }}>महावर पैलेस का भव्य उद्घाटन</p>
                                    <div className="divider"></div>

                                    <p><strong>आदरणीय बंधुजनों,</strong></p>
                                    <p>हमें आपको यह बताते हुए अत्यंत हर्ष हो रहा है कि आधुनिक सुविधाओं और भव्यता से सुसज्जित <span className="highlight">"महावर पैलेस"</span> अब आपकी सेवा में समर्पित होने जा रहा है।</p>

                                    <div className="mb-3 p-3 bg-light border rounded">
                                        <strong>दिनांक:</strong> <span class="text-primary fw-bold">21 जून 2026</span><br />
                                        <strong>स्थान:</strong> <span class="text-primary fw-bold">महावर पैलेस</span>, पुष्पांजलि हॉस्पिटल के पास, कर्नल राम सिंह चौक, प्लॉट नंबर 1, सेक्टर-4, बाईपास रोड, रेवाड़ी-123401, हरियाणा, भारत
                                    </div>

                                    <p>इस शुभ अवसर पर आयोजित उद्घाटन समारोह में आप सभी सादर आमंत्रित हैं। कृपया अपने <strong>परिवार और सगे-संबंधियों</strong> के साथ पधारकर हमें कृतार्थ करें और अपना स्नेहिल आशीर्वाद प्रदान करें।</p>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>
            <section class="bg-dark py-5">
                <Link to="/inauguration-ceremony" className="text-decoration-none">
                <div className="col-lg-12 text-center text-white fs-2 fw-bold">
                    महावर पैलेस के भव्य उद्घाटन समारोह की जानकारी पाने के लिए यहाँ क्लिक करें।
                </div>
                </Link>
            </section>

            {/* =========================================================
          Premium "About Mahawar Sabha" Heritage Section 
          ========================================================= */}
            <div id="about" className="bg-heritage-cream overflow-hidden">

                {/* 1. Hero Header */}
                <section className="container py-5 mt-4">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6 z-2">
                            <span className="badge bg-heritage-gold text-dark mb-3 px-3 py-2 rounded-pill fw-bold shadow-sm">
                                ABOUT US
                            </span>
                            <h2 className="display-4 fw-bold text-heritage-maroon mb-3 text-uppercase">
                                Mahawar Sabha
                            </h2>
                            <p className="lead fw-medium">
                                Learn More About Mahawar Sabha (Reg.), Rewari.
                            </p>

                            <div className="fs-6">
                                <p>
                                    हिंदू समाज की चतुष्वर्णीय व्यवस्था में सैकड़ों बनिया उपजातियाँ शामिल हैं| बनिया समुदाय की एक महत्वपूर्ण उपजाति है - महावर वैश्य| इन्हें व्यावसायिक वर्गों में अग्रणी माना जाता है| इस समुदाय का इतिहास भगवान कृष्ण जितना पुराना है और इन्हें इनके दानवीरता (generosity) के लिए जाना जाता है|
                                </p>
                                <p>
                                    महावर वैश्य (Mahawar Vaishya) हिंदू धर्म की मारवाड़ी बनिया जाति की एक श्रेणी, शाखा या उपजाति है| बता दें कि मारवाड़ी भारत का एक प्रमुख व्यापारिक समुदाय (trading community) और दक्षिण एशियाई जातीय-भाषाई समूह (ethno-linguistic group) है जो भारत के राजस्थान के मारवाड़ क्षेत्र से निकला है| इस समुदाय का इतिहास प्राचीन और गौरवशाली है| महावरों का इतिहास भगवान श्री कृष्ण के जितना पुराना है| महावर वैश्य समुदाय के लोग बनिया समुदाय में सबसे अच्छा व्यावसायिक वर्ग होने का दावा करते हैं| इनके अनुसार महावर शब्द की उत्पत्ति “महा+वर” से हुई है जिसका अर्थ होता है- “महान व्यवसायी या Great Businessman”|
                                </p>
                                <p>
                                    इस समुदाय के लोग पूरे भारत में और विदेशों में भी निवास करते हैं| लेकिन मुख्य रूप से यह राजस्थान, हरियाणा, पंजाब और उत्तर प्रदेश में निवास करते हैं|
                                </p>
                            </div>

                        </div>
                        <div className="col-lg-6 position-relative">
                            <div className="decorative-pattern-bg position-absolute top-50 start-50 translate-middle w-100 h-100 z-0"></div>
                            <div className="img-wrapper rounded-4 shadow-elegant overflow-hidden position-relative z-1 hover-lift">
                                <img src={mahawarImg} alt="Indian Temple" className="img-fluid w-100 img-heritage object-fit-cover" />
                                <div className="soft-overlay"></div>
                            </div>
                        </div>

                        <p class="mt-2">
                            राजस्थान में यह मुख्य रूप से अलवर और जयपुर जिलों में निवास करते हैं|  हरियाणा के गुरुग्राम और रेवाड़ी जिलों में इनकी आबादी है| उत्तर प्रदेश की बात करें तो मथुरा, सीतापुर, बिजनौर जिले के हल्दौर और अमरोहा जिले के हसनपुर में भी इनकी उपस्थिति है| पंजाब के जालंधर और फतेहगढ़ साहिब जिले के मंडी गोबिंदगढ़ में भी इस समुदाय के लोग निवास करते हैं|
                        </p>
                    </div>
                </section>
                {/* 7. Footer Mission Banner */}
                <div className="mission-banner py-5 text-center shadow-lg position-relative">
                    <div className="container py-5 position-relative z-1">
                        <h1 className="display-5 fw-bold text-white text-uppercase" style={{ letterSpacing: '2px', textShadow: '2px 2px 10px rgba(0,0,0,0.5)', fontSize: 'clamp(1.5rem, 5vw, 3rem)' }}>
                            "एकता, सेवा और संस्कार <br /> के साथ समाज का विकास"
                        </h1>
                    </div>
                </div>
                {/* Meet the Team Section */}
                <section id="team" className="team section py-5 bg-white">
                    <div className="container section-title text-center mb-5" data-aos="fade-up">
                        <h2 className="mt-5 fw-bold text-dark">Meet Our Office Bearers</h2>
                        <div className="separator mx-auto mb-3"></div>
                        <p className="">A dedicated team working towards the unity and progress of our community.</p>
                    </div>

                    <div className="container" data-aos="fade-up" data-aos-delay="100">
                        {/* Office Bearers & Executive Members */}
                        <div className="row g-4 justify-content-center">
                            {/* President */}
                            <div className="col-6 col-md-4">
                                <div className="team-member p-3 text-center">
                                    <div className="profile-wrapper mx-auto mb-3">
                                        <img src={rajeevImg} alt="Rajeev Gupta" className="profile-img img-fluid" />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1 fs-6">Rajeev Gupta</h5>
                                    <p className=" small mb-0 fs-6 fw-medium">President</p>
                                </div>
                            </div>

                            {/* Vice President */}
                            <div className="col-6 col-md-4">
                                <div className="team-member p-3 text-center">
                                    <div className="profile-wrapper mx-auto mb-3">
                                        <img src={nareshImg} alt="Naresh Gupta" className="profile-img img-fluid" />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1 fs-6">Naresh Gupta</h5>
                                    <p className=" small mb-0 fs-6 fw-medium">Vice President</p>
                                </div>
                            </div>

                            {/* Secretary */}
                            <div className="col-6 col-md-4">
                                <div className="team-member p-3 text-center">
                                    <div className="profile-wrapper mx-auto mb-3">
                                        <img src={subodhImg} alt="Subodh Gupta" className="profile-img img-fluid" />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1 fs-6">Subodh Gupta</h5>
                                    <p className=" small mb-0 fs-6 fw-medium">Secretary</p>
                                </div>
                            </div>

                            {/* Asst Secretary */}
                            <div className="col-6 col-md-4">
                                <div className="team-member p-3 text-center">
                                    <div className="profile-wrapper mx-auto mb-3">
                                        <img src={kapilImg} alt="Kapil Gupta" className="profile-img img-fluid" />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1 fs-6">Kapil Gupta</h5>
                                    <p className=" small mb-0 fs-6 fw-medium">Joint Secretary</p>
                                </div>
                            </div>

                            {/* Treasurer */}
                            <div className="col-6 col-md-4">
                                <div className="team-member p-3 text-center">
                                    <div className="profile-wrapper mx-auto mb-3">
                                        <img src={amitImg} alt="Amit Gupta" className="profile-img img-fluid" />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1 fs-6">Amit Gupta</h5>
                                    <p className=" small mb-0 fs-6 fw-medium">Treasurer</p>
                                </div>
                            </div>

                            {/* Executive Member */}
                            <div className="col-6 col-md-4">
                                <div className="team-member p-3 text-center">
                                    <div className="profile-wrapper mx-auto mb-3">
                                        <img src={niranjanImg} alt="Niranjan Lal Gupta" className="profile-img img-fluid" />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1 fs-6">Niranjan Lal Gupta</h5>
                                    <p className=" small mb-0 fs-6 fw-medium">Executive Member</p>
                                </div>
                            </div>

                            <div className="col-6 col-md-4">
                                <div className="team-member p-3 text-center">
                                    <div className="profile-wrapper mx-auto mb-3">
                                        <img src={HemantguptaImg} alt="Hemant Gupta" className="profile-img img-fluid" />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1 fs-6">Hemant Gupta</h5>
                                    <p className=" small mb-0 fs-6 fw-medium">Executive Member</p>
                                </div>
                            </div>

                            {/* Executive Member */}
                            <div className="col-6 col-md-4">
                                <div className="team-member p-3 text-center">
                                    <div className="profile-wrapper mx-auto mb-3">
                                        <img src={anilImg} alt="Anil Kumar Gupta" className="profile-img img-fluid" />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1 fs-6">Anil Kumar Gupta</h5>
                                    <p className=" small mb-0 fs-6 fw-medium">Executive Member</p>
                                </div>
                            </div>


                            {/* Executive Member */}
                            <div className="col-6 col-md-4">
                                <div className="team-member p-3 text-center">
                                    <div className="profile-wrapper mx-auto mb-3">
                                        <img src={tejparkashImg} alt="TejParkash" className="profile-img img-fluid" />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1 fs-6">TejParkash</h5>
                                    <p className=" small mb-0 fs-6 fw-medium">Executive Member</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                {/* 2. Main Introduction Card */}
                <section className="container py-5">
                    <div className="glass-card rounded-4 p-4 p-md-5 shadow-elegant border-gold position-relative">
                        <div className="text-center mb-5">
                            <div className="icon-gold-circle mx-auto mb-3 shadow-sm" style={{ width: '80px', height: '80px', fontSize: '32px' }}>
                                <i className="bi bi-bank2"></i>
                            </div>
                            <h2 className="fw-bold text-heritage-maroon">1940 <br></br>The Akhil Bharatvarsh Mahavar Vaish Mahasabha,<br></br> Annual Session November 17, 18, 19, at REWARI. </h2>
                        </div>

                        {/* Image Gallery Carousel */}
                        <div id="introGalleryCarousel" className="carousel slide mt-5 rounded-4  shadow-sm border-gold" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                {mahasabhaImages.map((img, index) => (
                                    <div key={index} className={`carousel-item bg-dark position-relative ${index === 0 ? 'active' : ''}`}>
                                        {/* Blurred background overlay so documents look framed nicely */}
                                        <div className="position-absolute top-0 start-0 w-100 h-100" style={{ backgroundImage: `url(${img})`, filter: 'blur(2px)', opacity: 0.6, transform: 'scale(1.1)', zIndex: 0 }}></div>
                                        <img src={img} className="d-block w-100 position-relative z-1 hover-lift" alt={`1940 Mahasabha Document ${index + 1}`} style={{ height: 'auto', maxHeight: '600px' }} />
                                    </div>
                                ))}
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#introGalleryCarousel" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true" style={{ filter: 'drop-shadow(0px 0px 5px rgba(0,0,0,0.8))' }}></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#introGalleryCarousel" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true" style={{ filter: 'drop-shadow(0px 0px 5px rgba(0,0,0,0.8))' }}></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>
                        <div className="text-center py-5">
                            <h5 className="fw-bold text-heritage-maroon">Presented on 01-03-2014 by: <br></br>Sh. Santosh Kumar Gupta, 7555, Moh. Baidwara, Rewari. T.No. 01274-255438.<br></br> Sh. Vidya Parkash Gupta, 314 Great India Apts. Plot-15, Sec-6 Dwarka, New Delhi-110075.Mob: 09910494424, T.No. 011-25089594, Email ID: vpld45@hotmail.com Sons of Late Lala Onkar Dass Ji B.A. of Moh. Baidwara, Rewari</h5>
                        </div>
                    </div>
                </section>

                {/* 3. Origin of Bania Section */}
                <section className="bg-white py-5">
                    <div className="container section-title text-center mb-5" data-aos="fade-up">
                        <h2 className="fw-bold text-heritage-maroon py-5 text-center">समाज के समर्पणीय प्रेरणादायी व्यक्तित्व</h2>
                        <div className="row g-5 align-items-center mb-5">
                            <div className="col-lg-4">
                                <div className="img-wrapper rounded-4 shadow-elegant overflow-hidden hover-lift border-gold">
                                    <img src={originimg} alt="Maharaja Agrasen Heritage" className="img-fluid img-heritage object-fit-cover" style={{ height: '500px', width: '100%', objectPosition: 'top' }} />
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="info-card p-4 rounded-3 shadow-sm mb-4 hover-lift">
                                    <h5 className="text-heritage-maroon fw-bold mb-2">स्व. लाला ओमकार दास जी बी.ए. रेवाड़ी</h5>
                                    <p className=" mb-0 fs-6" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                                        वर्ष 1931 से समाज सेवा से जुड़े। महासभा और सेवा संघ की स्थापना के बाद दोनों संस्थाओं की कार्यकारिणी में लगातार सदस्य रहे तथा 1940 में महासभा के रेवाड़ी अधिवेशन में स्वागत समिति में संयोजक के साथ-साथ सामान्य सचिव कार्य भी सम्पन्न किया। समाज द्वारा यू.पी. कमेटी का गठन उत्तरप्रदेश में समाज की स्थिति का अध्ययन कर रिपोर्ट देने को किया गया था, उसमें भी आपका योगदान रहा। नगर पालिका रेवाड़ी में आप वर्ष 1932 से 5 वर्ष तक म्यूनिसिपल कमिश्नर रहे। वित्तीय निरीक्षक हुआ था। हिन्दू हाई स्कूल रेवाड़ी में आपकी मैनेजर पद पर सेवाएँ उल्लेखनीय रही थीं। 1945 में हिन्दू हाई स्कूल भवन निर्माण में भी आप की महत्वपूर्ण भूमिका रही थी। वर्ष 1937 से जीवन पर्यन्त आप धर्मशाला किशनसहाय ट्रस्ट रेवाड़ी के प्रेसीडेण्ट पद पर आसीन रहे।<br></br><br></br>

                                        स्वाभिमानी और बात के धनी, समाज सेवा में समर्पित लाला ओमकार दास जी का जन्म वर्ष 1902 में रेवाड़ी में हुआ। रामजस कॉलेज दिल्ली से आपने बी.ए. की डिग्री प्राप्त की थी। तभी से अपने नाम के साथ बी.ए. लिखना प्रारम्भ किया और अन्त तक इसी नाम से विख्यात रहे। जीवन भर समाज सेवाओं से जुड़ाव के ऐसे उदाहरण कम ही मिलते हैं।

                                        <br></br><br></br>दो पुत्र, बड़े श्री सन्तोष कुमार गुप्ता DESU दिल्ली से प्रशासनिक अधिकारी पद से सेवा निवृत्त होकर वर्तमान में द्वारका ज्वैलर्स सर्राफा बाजार रेवाड़ी में व्यवसायी हैं। दूसरे सुपुत्र श्री विद्याप्रकाश गुप्ता (वी.पी. गुप्ता) नवम्बर 2005 में महाप्रबन्धक TCIL से सेवा निवृत्त होकर वर्तमान में रिलायन्स इण्डस्ट्रीज लिमिटेड के गुड़गांव संस्थान में जनरल मैनेजर के पद पर कार्यरत हैं। द्वारका दिल्ली में स्थायी निवास के साथ ही आप दिल्ली में समाज की कई संस्थाओं से जुड़कर अपनी बहुमूल्य सेवा प्रदान कर रहे हैं। यह सेवा भावना अपने पिताजी से ही विरासत में मिली है।

                                        <br></br><br></br>स्व. लाला ओमकार दास जी का व्यक्तित्व समाज सेवी महानुभावों को सतत प्रेरणा देता रहेगा।<br></br>

                                        <span>— सम्पादक</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Main Objectives / Social Welfare Section */}
                <section id="objectives" className="portfolio section py-5 bg-light">
                    <div className="container">
                        <h3 className="fw-bold mb-5 text-center fs-2 text-heritage-maroon" data-aos="fade-up">Message from the President</h3>
                        <div className="row align-items-stretch gy-4">

                            {/* President Box */}
                            <div className="col-lg-4" data-aos="fade-right">
                                <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden hover-lift">
                                    <img src={rajeevImg} className="card-img-top object-fit-cover" alt="Rajeev Gupta - President" style={{ height: '350px', objectPosition: 'top' }} />
                                    <div className="card-body p-4 bg-white text-center d-flex flex-column justify-content-center">
                                        <h5 className="fw-bold text-dark mb-1">Rajeev Gupta (President)</h5>
                                        <p className=" small mb-0 fs-6 fw-medium text-uppercase tracking-wide"> Mahawar Sabha (Reg.), Rewari</p>
                                    </div>
                                </div>
                            </div>

                            {/* Objectives Boxes */}
                            <div className="col-lg-8">
                                <div className="card border-0 shadow-sm rounded-4 h-100 p-4">

                                    <div className="mb-4">
                                        <span className="badge bg-warning text-dark px-3 py-2 mb-3">
                                            अध्यक्ष का दृष्टिकोण
                                        </span>

                                        <h4 className="fw-bold text-heritage-maroon">
                                            अध्यक्ष श्री राजीव गुप्ता जी का संदेश
                                        </h4>

                                        <p>
                                            महावर सभा (रजि.) के अध्यक्ष के रूप में, मेरा मुख्य उद्देश्य समाज में एकजुटता लाना, हमारी सांस्कृतिक विरासत को सहेजना और युवाओं को आगे बढ़ाकर समाज को एक नई दिशा देना है। हम सब मिलकर एक मजबूत और सशक्त महावर समाज का निर्माण कर सकते हैं।
                                        </p>
                                    </div>

                                    <div className="p-4 rounded-4 bg-light border-start border-4 border-warning mb-4 position-relative overflow-hidden">
                                        <i className="bi bi-quote position-absolute top-0 end-0 text-warning opacity-25" style={{ fontSize: '5rem', marginTop: '-20px', marginRight: '-10px' }}></i>
                                        <h5 className="text-heritage-maroon fw-bold mb-2 position-relative z-1">
                                            "संगच्छध्वं संवदध्वं सं वो मनांसि जानताम्।"
                                        </h5>
                                        <p className="text-dark mb-0 position-relative z-1 fs-6">
                                            अर्थात: हम सब एक साथ चलें, एक साथ बोलें, और हमारे विचार एक हों।
                                        </p>
                                    </div>

                                    <p className="fw-medium text-dark mb-0">
                                        एकता, सहयोग और भाईचारे से ही समाज का वास्तविक उत्थान संभव है। मेरा आप सभी से यही आग्रह है कि हम अपनी समृद्ध महावर विरासत पर गर्व करें, अपने संस्कारों को जीवित रखें और एक-दूसरे के साथ कंधे से कंधा मिलाकर खड़े हों। महावर सभा का मुख्य उद्देश्य समाज में एकता, शिक्षा, संस्कार एवं सामाजिक उत्थान को बढ़ावा देना है।
                                    </p>

                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                {/* 4. Photo Gallery Preview Section */}
                <section className="container py-3">
                    <div className="text-center mb-5" data-aos="fade-up">
                        <h2 className="fw-bold text-heritage-maroon">Our Photo Gallery</h2>
                        <div className="mx-auto mt-2" style={{ width: '60px', height: '3px', background: 'linear-gradient(to right, #7A1F1F, #D4A017)', borderRadius: '2px' }}></div>
                        <p className="mt-3 text-muted">A glimpse into our community events and rich heritage.</p>
                    </div>

                    <div className="row g-4 justify-content-center">
                        {[
                            {
                                id: 'annual-day',
                                title: 'Annual Day',
                                image: anualday,
                                count: '10+ Photos',
                                link: '/gallery#annual-day'
                            },
                            {
                                id: 'holi',
                                title: 'Holi Celebration',
                                image: holi1Img,
                                count: '15+ Photos',
                                link: '/gallery#holi'
                            },
                            {
                                id: 'blood-donation',
                                title: 'Blood Donation',
                                image: blooddonation,
                                count: '8+ Photos',
                                link: '/activity#blood-donation'
                            },
                            {
                                id: 'planting',
                                title: 'Tree Plantation',
                                image: planting,
                                count: `8+ Photos`,
                                link: '/activity#planting'
                            }
                        ].map((album, idx) => (
                            <div className="col-12 col-sm-6 col-lg-3" key={idx} data-aos="fade-up" data-aos-delay={idx * 100}>
                                <Link to={album.link} className="card border-gold shadow-sm rounded-4 overflow-hidden hover-lift h-100 text-decoration-none d-block">
                                    <div className="position-relative overflow-hidden" style={{ height: '220px' }}>
                                        <img src={album.image} alt={album.title} className="w-100 h-100 object-fit-cover transition-transform" style={{ transition: 'transform 0.4s ease' }} />
                                        <div className="position-absolute bottom-0 start-0 w-100 p-3" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)' }}>
                                            <span className="badge bg-warning text-dark">{album.count}</span>
                                        </div>
                                    </div>
                                    <div className="card-body text-center bg-white">
                                        <h6 className="fw-bold mb-0 text-heritage-maroon">{album.title}</h6>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-5 " data-aos="fade-up" >
                        <Link to="/gallery" className="btn btn-outline-danger rounded-pill px-5 py-2 m-3 hover-lift fw-bold border-2">
                            View All Albums <i className="bi bi-images ms-2"></i>
                        </Link>
                        <Link to="/Activity" className="btn btn-outline-danger rounded-pill px-5 py-2 m-3 hover-lift ms-auto fw-bold border-2">
                            View All Activities <i className="bi bi-images ms-2"></i>
                        </Link>
                    </div>
                </section>
                <section >
                    <div className="glass-card  p-4 p-md-5 shadow-elegant border-gold position-relative">
                        <h2 className="fw-bold text-heritage-maroon text-center">Our Media Gallery</h2>
                        <p className="mt-3 text-muted text-center">
                            A glimpse into our community events and rich heritage.
                        </p>
                        {/* Image Gallery Carousel */}
                        <Link to="/media">
                            <div id="intrCarousel" className="carousel slide mt-5  overflow-hidden shadow-sm border-gold" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    {mediaImages.map((img, index) => (
                                        <div key={index} className={`carousel-item bg-dark position-relative ${index === 0 ? 'active' : ''}`}>
                                            {/* Blurred background overlay so documents look framed nicely */}
                                            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ backgroundImage: `url(${img})`, backgroundSize: 'cover', backgroundPosition: 'center', filter: 'blur(8px)', opacity: 0.6, transform: 'scale(1.1)', zIndex: 0 }}></div>
                                            <img src={img} className="d-block w-100 position-relative z-1 hover-lift" alt={`1940 Mahasabha Document ${index + 1}`} style={{ height: 'auto', maxHeight: '800px' }} />
                                        </div>
                                    ))}
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#intrCarousel" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true" style={{ filter: 'drop-shadow(0px 0px 5px rgba(0,0,0,0.8))' }}></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#intrCarousel" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true" style={{ filter: 'drop-shadow(0px 0px 5px rgba(0,0,0,0.8))' }}></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div></Link>
                        <div className="text-center mt-5 " data-aos="fade-up" >
                            <Link to="/media" className="btn btn-outline-danger rounded-pill px-5 py-2 m-3 hover-lift fw-bold border-2">
                                View All  <i className="bi bi-images ms-2"></i>
                            </Link>
                        </div>
                    </div>
                </section>

                <section className="container py-5 mb-5">
                    <div className="glass-card rounded-4 p-4 p-lg-5 shadow-elegant border-gold">
                        <div className="row g-5 align-items-center">
                            <div className="col-lg-6">
                                <h2 className="fw-bold text-heritage-maroon mb-4">A Wealthy & Influential Community</h2>
                                <p className=" mb-0 fs-6">
                                    बनिया एक अमीर और प्रभावशाली समुदाय है। देश की अर्थव्यवस्था पर इनका नियंत्रण है, क्योंकि ज़्यादातर उद्योगपति इसी समुदाय से आते हैं।
                                </p>
                                <div className="row g-3 mt-2">
                                    {['संपत्ति का सृजन', 'व्यावसायिक उत्कृष्टता', 'औद्योगिक विकास', 'आर्थिक शक्ति'].map((trait, idx) => (
                                        <div className="col-sm-6" key={idx}>
                                            <div className="p-3 bg-white rounded-3 shadow-sm border-start border-4 border-warning hover-lift text-heritage-maroon fw-bold fs-5">
                                                <i className="bi bi-check-circle-fill text-heritage-gold me-2"></i> {trait}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="img-wrapper rounded-4 shadow-sm overflow-hidden hover-lift">
                                    <img src={economyimg} alt="Industrial Skyline" className="img-fluid w-100 object-fit-cover" style={{ height: '300px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>

            {/* FAQ Section */}
            <section id="faq" className="faq-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container py-4">
                    <div className="text-center mb-5" data-aos="fade-up">
                        <h2 className="fw-bold" style={{ color: '#0d1b2a' }}>Frequently Asked Questions</h2>
                        <div className="mx-auto mt-2" style={{ width: '60px', height: '3px', background: 'linear-gradient(to right, #8c1c13, #0d1b2a)', borderRadius: '2px' }}></div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">

                            {/* FAQ Item 1 */}
                            <div className="row faq-item align-items-start mb-4" data-aos="fade-up" data-aos-delay="100">
                                <div className="col-md-4 d-flex align-items-start mb-3 mb-md-0">
                                    <i className="bi bi-question-circle-fill faq-icon me-3 mt-1" style={{ color: '#e74c3c', fontSize: '1.5rem', transition: 'all 0.3s ease' }}></i>
                                    <h5 className="fw-bold mb-0 fs-6" style={{ color: '#0d1b2a', fontSize: '1.1rem', lineHeight: '1.4' }}>What is Mahawar Samaaj and what are its main objectives?</h5>
                                </div>
                                <div className="col-md-8">
                                    <p className=" mb-0 fs-6 lh-lg">Mahawar Samaaj is a community organization dedicated to social welfare, cultural preservation, and youth development. We conduct health camps, food distribution drives, cultural programs, and youth activities to support and unite our community members.</p>
                                </div>
                            </div>
                            <hr className=" opacity-25 mb-4" />

                            {/* FAQ Item 2 */}
                            <div className="row faq-item align-items-start mb-4" data-aos="fade-up" data-aos-delay="200">
                                <div className="col-md-4 d-flex align-items-start mb-3 mb-md-0">
                                    <i className="bi bi-question-circle-fill faq-icon me-3 mt-1" style={{ color: '#e74c3c', fontSize: '1.5rem', transition: 'all 0.3s ease' }}></i>
                                    <h5 className="fw-bold mb-0 fs-6" style={{ color: '#0d1b2a', fontSize: '1.1rem', lineHeight: '1.4' }}>Who can become a member of Mahawar Samaaj?</h5>
                                </div>
                                <div className="col-md-8">
                                    <p className=" mb-0 fs-6 lh-lg">Any individual belonging to the Mahawar community, or closely associated with it, who believes in our values of unity, service, and cultural preservation can become a member, subject to the guidelines of Mahawar Sabha (Reg.), Rewari.</p>
                                </div>
                            </div>
                            <hr className=" opacity-25 mb-4" />

                            {/* FAQ Item 3 */}
                            <div className="row faq-item align-items-start mb-4" data-aos="fade-up" data-aos-delay="300">
                                <div className="col-md-4 d-flex align-items-start mb-3 mb-md-0">
                                    <i className="bi bi-question-circle-fill faq-icon me-3 mt-1" style={{ color: '#e74c3c', fontSize: '1.5rem', transition: 'all 0.3s ease' }}></i>
                                    <h5 className="fw-bold mb-0 fs-6" style={{ color: '#0d1b2a', fontSize: '1.1rem', lineHeight: '1.4' }}>How does the Samaaj help underprivileged members of the community?</h5>
                                </div>
                                <div className="col-md-8">
                                    <p className=" mb-0 fs-6 lh-lg">We support underprivileged families through medical camps, financial assistance in emergencies, education support when possible, and food distribution during special drives or difficult times. The aim is to ensure dignity, basic support, and timely help for those in need.</p>
                                </div>
                            </div>
                            <hr className=" opacity-25 mb-4" />

                            {/* FAQ Item 4 */}
                            <div className="row faq-item align-items-start mb-4" data-aos="fade-up" data-aos-delay="400">
                                <div className="col-md-4 d-flex align-items-start mb-3 mb-md-0">
                                    <i className="bi bi-question-circle-fill faq-icon me-3 mt-1" style={{ color: '#e74c3c', fontSize: '1.5rem', transition: 'all 0.3s ease' }}></i>
                                    <h5 className="fw-bold mb-0 fs-6" style={{ color: '#0d1b2a', fontSize: '1.1rem', lineHeight: '1.4' }}>What types of cultural programs does Mahawar Samaaj organize?</h5>
                                </div>
                                <div className="col-md-8">
                                    <p className=" mb-0 fs-6 lh-lg">We organize traditional festivals, religious and social gatherings, felicitation programs, and cultural evenings that include bhajans, folk music, and community meals. These events help us preserve our customs and strengthen bonds across all age groups.</p>
                                </div>
                            </div>
                            <hr className=" opacity-25 mb-4" />

                            {/* FAQ Item 5 */}
                            <div className="row faq-item align-items-start" data-aos="fade-up" data-aos-delay="500">
                                <div className="col-md-4 d-flex align-items-start mb-3 mb-md-0">
                                    <i className="bi bi-question-circle-fill faq-icon me-3 mt-1" style={{ color: '#e74c3c', fontSize: '1.5rem', transition: 'all 0.3s ease' }}></i>
                                    <h5 className="fw-bold mb-0 fs-6" style={{ color: '#0d1b2a', fontSize: '1.1rem', lineHeight: '1.4' }}>How can youth participate and volunteer in Mahawar Samaaj activities?</h5>
                                </div>
                                <div className="col-md-8">
                                    <p className=" mb-0 fs-6 lh-lg">Young members can volunteer in health camps, charity drives, cultural events, and digital promotion of Samaaj activities. We also encourage them to take leadership roles in planning events, coordinating teams, and introducing new ideas that benefit the community.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </MainLayout>
    );
}

export default Home;
